// components/Settings/knowledge/KnowledgeWorkspace.jsx
import DataTab from "./data/DataTab";
import InstructionsTab from "./instructions/InstructionsTab";
import { Database, FileCode, Loader2 } from "lucide-react";

export default function KnowledgeWorkspace({
  activeMode,
  configId,
  configDbType,
  loading,
  initialInstructionTab = "general",
}) {
  
  // Loading state - compact version
  if (loading) {
    return (
      <div className="h-full flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 size={32} className="animate-spin text-primary mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // No database selected - compact version
  if (!configId) {
    return (
      <div className="h-full flex items-center justify-center bg-background p-6">
        <div className="max-w-md text-center">
          <div className="inline-flex p-4 bg-muted/50 rounded-xl mb-4">
            <Database size={32} className="text-muted-foreground" />
          </div>
          
          <h3 className="text-base font-semibold mb-2">No Database Selected</h3>
          
          <p className="text-sm text-muted-foreground mb-4">
            Select a database from the dropdown above to configure AI knowledge
          </p>

          <div className="grid grid-cols-2 gap-2 text-left">
            <div className="p-3 bg-card border rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <Database size={16} className="text-primary" />
                <h4 className="text-xs font-semibold">Data</h4>
              </div>
              <p className="text-xs text-muted-foreground">
                Table & column definitions
              </p>
            </div>
            
            <div className="p-3 bg-card border rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <FileCode size={16} className="text-primary" />
                <h4 className="text-xs font-semibold">Instructions</h4>
              </div>
              <p className="text-xs text-muted-foreground">
                Custom AI guidelines
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Instructions mode
  if (activeMode === "instructions") {
    return (
      <InstructionsTab
        configId={configId}
        dbType={configDbType}
        initialActiveTab={initialInstructionTab}
      />
    );
  }

  // Data mode (default)
  return <DataTab configId={configId} />;
}
